import { getColor } from '../../../../theme-tools';
import { inputBaseStyles } from '../commonBasedStyles';
var getContainerStyles = () => {
  var {
    base
  } = inputBaseStyles;
  return {
    borderRadius: '3px',
    borderColor: base.borderColor,
    width: '100%',
    display: 'flex',
    position: 'relative',
    transition: 'all 0.2s'
  };
};
var getVariantOutline = props => {
  var {
    theme
  } = props;
  var {
    base,
    focus,
    disabled,
    invalid,
    invalidFocus
  } = inputBaseStyles;
  return {
    field: {
      h3: {
        color: base.errorTextColor
      },
      py: '10px',
      px: '16px',
      borderColor: base.borderColor,
      borderRadius: base.borderRadius,
      _placeholder: {
        color: base.placeHolderColor
      },
      _disabled: {
        backgroundColor: disabled.bg,
        borderColor: disabled.borderColor,
        color: disabled.color,
        borderWidth: disabled.borderWidth
      },
      _focus: {
        borderRadius: focus.borderRadius,
        borderColor: focus.borderColor,
        boxShadow: "0 0 4px 1px ".concat(getColor(theme, focus.boxShadowColor))
      },
      _invalid: {
        borderColor: invalid.borderColor,
        borderWidth: invalid.borderWidth,
        boxShadow: 'none',
        _focus: {
          boxShadow: "0 0 4px 1px ".concat(getColor(theme, invalidFocus.boxShadowColor)),
          borderColor: invalidFocus.borderColor,
          outline: 'none'
        }
      }
    },
    addon: {
      borderRadius: '0 3px 3px 0',
      bg: base.borderColor
    }
  };
};
var baseStyle = () => ({
  container: getContainerStyles()
});
export var Input = {
  baseStyle,
  variants: {
    outline: getVariantOutline
  }
};